(function($) {

    $(document).ready(function() {

        if ($('.cards-carousel').length > 0 && $("#also-like").length == 0) {
            setTimeout(function() {
                $(".cards-carousel .row-wrapper").css({ "opacity": "1" });
            }, 500);

            var numSlick = 0;
            $('.cards-carousel').each(function() {
                numSlick++;
                $(this).find('.row-wrapper').addClass('slider-' + numSlick).slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: 'linear',
                    prevArrow: $(this).find('.col-left .arrow-btns .slick-prev'),
                    nextArrow: $(this).find('.col-left .arrow-btns .slick-next'),
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }]
                });
            });
        }

        $(".cards-carousel .col-left h2").each(function() {
            var card_length = $(this).text();
            if (card_length === 'Past Essay Series') {
                $(this).parent().parent().parent().addClass("cards-carousel-series");
                $(this).parent().parent().parent().removeClass("cards-carousel");
                setTimeout(function() {
                    $(".cards-carousel-series").find(".row-wrappert").slick('unslick');
                }, 600);
            }
        });

        $(".cards-carousel .col-left h2").each(function() {
            var card_length = $(this).text();
            if (card_length === 'Featured Essay Series') {
                $(this).parent().parent().parent().addClass("cards-carousel-series");
                $(this).parent().parent().parent().removeClass("cards-carousel");
                setTimeout(function() {
                    $(".cards-carousel-series").find(".row-wrapper").slick('unslick');
                }, 600);
            }
        });

        setTimeout(function() {
            if ($('.cards-carousel-series').length > 0) {
                $(".cards-carousel-series .row-wrapper").css({ "opacity": "1" });
                $('.cards-carousel-series .row-wrapper').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: 'linear',
                    prevArrow: $('.cards-carousel-series .col-left .arrow-btns .slick-prev'),
                    nextArrow: $('.cards-carousel-series .col-left .arrow-btns .slick-next'),
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }]
                });

            }
        }, 800);
    });
})(jQuery);